export var NMPKeyboardShortcuts;
(function (NMPKeyboardShortcuts) {
    NMPKeyboardShortcuts["POLICY_NOTICE"] = "A";
    NMPKeyboardShortcuts["DATA_ENTRY"] = "D";
    NMPKeyboardShortcuts["LEGEND"] = "K";
    NMPKeyboardShortcuts["DISCOUNTS"] = "O";
    NMPKeyboardShortcuts["CREATE_DOCUMENT"] = "P";
    NMPKeyboardShortcuts["SAVE"] = "S";
})(NMPKeyboardShortcuts || (NMPKeyboardShortcuts = {}));
